import { call, put, takeEvery } from "redux-saga/effects";
import { worldCupRankingsRequest } from "../../api/worldCupRankings";
import { WORLD_CUP_RANKINGS_REQUEST } from "../../constants/worldCupRankings";
import { worldCupRankingsActions } from "../../store/worldCupRankings/actions";

function* worldCupRankingsRequestSaga(): any {
  try {
    const worldCupRankings = yield call(worldCupRankingsRequest);
    yield put(
      worldCupRankingsActions.worldCupRankingsSuccessAction(worldCupRankings)
    );
  } catch (e: any) {
    yield put(worldCupRankingsActions.worldCupRankingsFailureAction(e));
  }
}
function* worldCupRankingsSaga() {
  yield takeEvery(WORLD_CUP_RANKINGS_REQUEST, worldCupRankingsRequestSaga);
}

export default worldCupRankingsSaga;
